import { render } from "./AssetTypes.vue?vue&type=template&id=1074f218&ts=true"
import script from "./AssetTypes.vue?vue&type=script&lang=ts"
export * from "./AssetTypes.vue?vue&type=script&lang=ts"

import exportComponent from "/data/jenkins/workspace/PROD/SwissApp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__